import { orderBy, where } from "firebase/firestore";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaFilter } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { PiSortAscendingBold, PiSortDescendingBold } from "react-icons/pi";
import Select, { components, createFilter } from "react-select";

import { useOrganizationCollection } from "../../api/firestoreWrappers.generated.jsx";
import SearchQueryInput from "../SearchQueryInput/index.jsx";

export default function UserFilters({
    filters,
    setFilters,
    order,
    setOrder,
    sortCriteria,
    setSortCriteria,
    setSearchQuery,
    searchQuery,
    filterOptions,
    sortOptions,
}) {
    const [organizations] = useOrganizationCollection([
        where("deleted", "==", false),
        orderBy("name", "asc"),
    ]);

    const handleFilter = (selectedOptions) => {
        setFilters((prev) => ({
            ...prev,
            singleFilters: selectedOptions ?? [],
        }));
    };

    const selectedOptions = filters.singleFilters ?? [];
    const selectedValues = new Set(selectedOptions.map((o) => o.value));

    const visibleOptions = format(
        filterOptions.filter(
            (group) => !group.some((opt) => selectedValues.has(opt.value)),
        ),
    );

    function format(arr) {
        const map = new Map();
        for (const opt of arr.flat()) {
            map.set(opt.value, opt);
        }
        return [...map.values()];
    }

    const FilterOption = ({ selected, items, title }) => {
        const options = items.map((opt) => ({
            value: opt.id ?? opt,
            label: opt.name ?? opt,
        }));

        return (
            <Select
                className="w-50 me-2"
                components={{ Control: FilterSelect }}
                isClearable={!!items}
                value={options.find((item) => item.value === selected)}
                options={options}
                placeholder={`Filter ${title}`}
                filterOption={createFilter({
                    stringify: (option) => option.label,
                })} // Only match labels when typing
                onChange={(e) =>
                    setFilters({
                        ...filters,
                        organizationId:
                            title === "Organizations"
                                ? e?.value
                                : filters.organizationId,
                    })
                }
                styles={{
                    menu: (base) => ({
                        ...base,
                        zIndex: 9999,
                    }),
                }}
            />
        );
    };

    const FilterSelect = (props) => (
        <components.Control {...props}>
            <FaFilter style={{ marginLeft: 8 }} className="text-secondary" />
            {props.children}
        </components.Control>
    );

    const SortSelect = (props) => (
        <components.Control {...props}>
            <Button
                className="p-0 ps-2 bg-transparent text-black border-0 d-flex align-items-center"
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOrder((prev) => (prev === "desc" ? "asc" : "desc"));
                }}
            >
                {order === "asc" ? (
                    <PiSortAscendingBold size={20} />
                ) : (
                    <PiSortDescendingBold size={20} />
                )}
            </Button>
            {props.children}
        </components.Control>
    );

    return (
        <Form.Group className="w-100">
            <Row>
                <Col>
                    <SearchQueryInput
                        defaultValue={searchQuery}
                        placeholder={"Search users"}
                        onValueChange={(val) => setSearchQuery(val)}
                    />
                </Col>
            </Row>
            <Row className="m-0 d-flex justify-content-between">
                <Col md={7} className="p-0 pe-md-1 d-flex mt-2">
                    <FilterOption
                        selected={filters?.organizationId}
                        items={organizations}
                        title="Organizations"
                    />
                    <Select
                        className="w-50"
                        components={{ Control: FilterSelect }}
                        isMulti
                        options={visibleOptions}
                        value={selectedOptions}
                        onChange={handleFilter}
                        controlShouldRenderValue={false}
                        placeholder="Add filters..."
                        filterOption={createFilter({
                            stringify: (option) => option.label,
                        })} // Only match labels when typing
                        styles={{
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                        }}
                    />
                </Col>

                <Col md={3} className="p-0 mt-2">
                    <Select
                        components={{ Control: SortSelect }}
                        options={sortOptions}
                        value={sortCriteria}
                        onChange={setSortCriteria}
                        placeholder="Sort"
                        filterOption={createFilter({
                            stringify: (option) => option.label,
                        })} // Only match labels when typing
                        styles={{
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="selected-items mt-2 d-flex">
                        {selectedOptions.map((opt) => (
                            <div
                                key={opt.value}
                                className="me-2 ps-1 rounded-1 border border-1 d-flex align-items-center alert-secondary"
                            >
                                {opt.label}
                                <button
                                    type="button"
                                    className="border-0 alert-secondary d-flex align-items-center"
                                    onClick={() =>
                                        setFilters((prev) => ({
                                            ...prev,
                                            singleFilters:
                                                prev.singleFilters.filter(
                                                    (f) =>
                                                        f.value !== opt.value,
                                                ),
                                        }))
                                    }
                                >
                                    <ImCross
                                        size={14}
                                        className="text-secondary"
                                    />
                                </button>
                            </div>
                        ))}
                    </div>
                </Col>
            </Row>
        </Form.Group>
    );
}
